import { Inject, Injectable } from '@angular/core';
import { Environment } from '@thiememeulenhoff/types';
import { API_CONFIG, ApiGatewayConfig } from '..';

@Injectable({
  providedIn: 'root',
})
export class ServicesService {
  constructor(@Inject(API_CONFIG) private config: ApiGatewayConfig) {} // eslint-disable-line

  public arrange(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}arrange.thiememeulenhoff.nl/api/${endpoint}`;
  }

  public thip(endpoint: string, version = 2) {
    return `https://${this.#environmentApiPrefix()}thip.thiememeulenhoff.nl/api/v${version}/${endpoint}`;
  }

  public thor(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}thor.thiememeulenhoff.nl/api/v1/${endpoint}`;
  }

  public groupServices(endpoint: string) {
    return `https://${this.#environmentGroupServiceApiPrefix()}groupservices.thiememeulenhoff.nl/${endpoint}`;
  }

  public userService(endpoint: string) {
    const prefix = [
      Environment.Production,
      Environment.Staging,
      'prod',
    ].includes(this.config.environment)
      ? ''
      : `test.`;

    return `https://${prefix}user-service.thiememeulenhoff.nl/api/v1/${endpoint}`;
  }

  public edition(endpoint: string) {
    return `https://${this.#environmentApiPrefix()}edition.thiememeulenhoff.nl/secure/next/api/${endpoint}`;
  }

  public platform(endpoint: string) {
    const prefix = [
      Environment.Production,
      Environment.Staging,
      'prod',
    ].includes(this.config.environment)
      ? ''
      : `test.`;

    return `https://${prefix}platforms.thiememeulenhoff.nl/api/${endpoint}`;
  }

  #isProduction() {
    // TODO: check why 'prod' is used as environment, and not 'production'
    return [Environment.Production, 'prod'].includes(this.config.environment);
  }

  #isStaging() {
    return [Environment.Staging, 'stag'].includes(this.config.environment);
  }

  #isAcceptance() {
    return [Environment.Acceptance, 'acc'].includes(this.config.environment);
  }

  #environmentGroupServiceApiPrefix() {
    if (this.#isStaging() || this.#isProduction()) {
      return '';
    }

    if (this.#isAcceptance()) {
      return 'test.';
    }

    return `${this.config.environment}.`;
  }

  #environmentApiPrefix() {
    return this.#isProduction() ? '' : `${this.config.environment}.`;
  }
}
